export default {"src":"/_next/static/media/greenCircle.a1dd5886.svg","height":33,"width":32,"blurWidth":0,"blurHeight":0};